import {createFileRoute, Outlet, redirect, useLocation} from '@tanstack/react-router';
import {PAYMENT_ORDER_LIST} from '@/patient/routing/paths';
import PaimentOrderList from '@/patient/views/payments/PaymentOrderList';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

function PaymentOrderLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === PAYMENT_ORDER_LIST;
  return isRoot ? <PaimentOrderList /> : <Outlet />;
}

export const Route = createFileRoute('/(patient)/patient/payment-orders')({
  component: PaymentOrderLayout,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.isPatient && context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
  }
});
